import type { Locale } from "./locales";

/**
 * Noto Sans and Barlow Condensed (index.html) have no Thai, Myanmar, Khmer or
 * Lao glyphs. The theme font stack falls back to the Noto Sans faces per
 * glyph (styles.css), but the Myanmar script in particular is missing from
 * many Android and older Windows devices — so the face has to be a webfont,
 * and loading all four for every visitor would punish the 6 Latin-script
 * locales. Inject the <link> only when a locale that needs it becomes
 * active, once per family.
 */

const FONT_BY_LOCALE: Partial<Record<Locale, string>> = {
	th: "Noto+Sans+Thai",
	my: "Noto+Sans+Myanmar",
	km: "Noto+Sans+Khmer",
	lo: "Noto+Sans+Lao",
};

const loaded = new Set<string>();

export function ensureLocaleFont(locale: Locale): void {
	const family = FONT_BY_LOCALE[locale];
	if (!family || loaded.has(family)) return;
	loaded.add(family);

	const link = document.createElement("link");
	link.rel = "stylesheet";
	// 400–700 mirrors the body weights the UI actually uses.
	link.href = `https://fonts.googleapis.com/css2?family=${family}:wght@400;500;600;700&display=swap`;
	document.head.append(link);
}
